import React, { useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

function GalleryLightbox({ images, index, onChange, onClose }) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
      if (event.key === 'ArrowRight') onChange((index + 1) % images.length);
      if (event.key === 'ArrowLeft') onChange((index - 1 + images.length) % images.length);
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [images.length, index, onChange, onClose]);

  const previous = () => onChange((index - 1 + images.length) % images.length);
  const next = () => onChange((index + 1) % images.length);

  return (
    <div className="gallery-lightbox">
      <button
        type="button"
        className="gallery-lightbox__backdrop"
        aria-label="Close image gallery"
        onClick={onClose}
      />
      <div className="gallery-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Beauty work gallery">
        <button
          type="button"
          className="gallery-lightbox__close"
          aria-label="Close image"
          onClick={onClose}
        >
          <SafeIcon icon={FiIcons.FiX} />
        </button>
        <button
          type="button"
          className="gallery-lightbox__control gallery-lightbox__previous"
          aria-label="Previous image"
          onClick={previous}
        >
          <SafeIcon icon={FiIcons.FiChevronLeft} />
        </button>
        <img
          className="gallery-lightbox__image"
          src={images[index]}
          alt={`Beauty work ${index + 1} of ${images.length}`}
        />
        <button
          type="button"
          className="gallery-lightbox__control gallery-lightbox__next"
          aria-label="Next image"
          onClick={next}
        >
          <SafeIcon icon={FiIcons.FiChevronRight} />
        </button>
        <p className="gallery-lightbox__counter">{index + 1} / {images.length}</p>
      </div>
    </div>
  );
}

export default GalleryLightbox;
